import React from 'react';

const InterestsSection = ({
  userInterests,
  userInterestInput,
  setUserInterestInput,
  interestErrorMessage,
  onSubmitInterest,
  onRemoveInterest
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSubmitInterest();
      e.preventDefault();
    }
  };

  return (
    <div className="user-interests-section">
      <div className="interest-input-container">
        <input
          type="text"
          className="interest-input"
          placeholder="Type interests to discuss with AI, and press Enter"
          value={userInterestInput}
          onChange={(e) => setUserInterestInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        {interestErrorMessage && (
          <div className="error-message">{interestErrorMessage}</div>
        )}
      </div>

      {userInterests.length > 0 && (
        <div className="interests-container">
          {userInterests.map((interest, index) => (
            <span className="interest-bubble" key={index}>
              {interest}
              <button
                className="remove-button"
                onClick={() => onRemoveInterest(index)}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default InterestsSection;
